"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { AuthContext } from "@/components/auth/Auth";
import { ApiWavesOverviewType } from "@/generated/models/ApiWavesOverviewType";
import WavesListWrapper from "./WavesListWrapper";
import WavesListHeader from "./header/WavesListHeader";
import WavesListSearchResults from "./WavesListSearchResults";
export default function WavesList(t0) {
  const $ = _c(46);
  const {
    heading: t1,
    showCreateNewButton,
    onCreateNewWave,
    onCreateNewDirectMessage
  } = t0;
  const heading = t1 === undefined ? "Waves" : t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const [showAllType, setShowAllType] = useState(null);
  let t2;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile?.handle || $[2] !== showAllType) {
    t2 = () => {
      const types = showAllType ? Object.values(ApiWavesOverviewType).filter(t => t === showAllType) : Object.values(ApiWavesOverviewType);
      if (!connectedProfile?.handle || !!activeProfileProxy) {
        return types.filter(_temp);
      }
      return types;
    };
    $[0] = activeProfileProxy;
    $[1] = connectedProfile?.handle;
    $[2] = showAllType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getWaveOverviewTypes = t2;
  let t3;
  if ($[4] !== getWaveOverviewTypes) {
    t3 = getWaveOverviewTypes();
    $[4] = getWaveOverviewTypes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [overviewTypes, setOverviewTypes] = useState(t3);
  let t4;
  if ($[6] !== getWaveOverviewTypes) {
    t4 = () => setOverviewTypes(getWaveOverviewTypes());
    $[6] = getWaveOverviewTypes;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== activeProfileProxy || $[9] !== connectedProfile || $[10] !== showAllType) {
    t5 = [connectedProfile, activeProfileProxy, showAllType];
    $[8] = activeProfileProxy;
    $[9] = connectedProfile;
    $[10] = showAllType;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== searchParams) {
    t6 = searchParams.get("identity") || null;
    $[12] = searchParams;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const [identity, setIdentity] = useState(t6);
  const [waveName, setWaveName] = useState(null);
  let t7;
  if ($[14] !== pathname || $[15] !== router || $[16] !== searchParams) {
    t7 = newIdentity => {
      setIdentity(newIdentity);
      const newQuery = new URLSearchParams(searchParams.toString());
      if (!newIdentity || newIdentity.trim() === "") {
        newQuery.delete("identity");
      } else {
        newQuery.set("identity", newIdentity);
      }
      router.push(newQuery.toString() ? `${pathname}?${newQuery.toString()}` : pathname ?? "");
    };
    $[14] = pathname;
    $[15] = router;
    $[16] = searchParams;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const updateIdentity = t7;
  let t8;
  if ($[18] !== identity || $[19] !== waveName) {
    t8 = () => !!identity || !!waveName;
    $[18] = identity;
    $[19] = waveName;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const getShowSearchResults = t8;
  const [showSearchResults, setShowSearchResults] = useState(getShowSearchResults());
  let t9;
  if ($[21] !== getShowSearchResults || $[22] !== searchParams) {
    t9 = () => {
      setShowSearchResults(getShowSearchResults());
      setIdentity(searchParams.get("identity") || null);
    };
    $[21] = getShowSearchResults;
    $[22] = searchParams;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== searchParams) {
    t10 = searchParams.toString();
    $[24] = searchParams;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== waveName) {
    t11 = [t10, waveName];
    $[26] = t10;
    $[27] = waveName;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  useEffect(t9, t11);
  let t12;
  if ($[29] !== heading || $[30] !== identity || $[31] !== onCreateNewDirectMessage || $[32] !== onCreateNewWave || $[33] !== showCreateNewButton || $[34] !== updateIdentity || $[35] !== waveName) {
    t12 = <WavesListHeader title={heading} identity={identity} waveName={waveName} showCreateNewButton={showCreateNewButton} onCreateNewWave={onCreateNewWave} onCreateNewDirectMessage={onCreateNewDirectMessage} setIdentity={updateIdentity} setWaveName={setWaveName} />;
    $[29] = heading;
    $[30] = identity;
    $[31] = onCreateNewDirectMessage;
    $[32] = onCreateNewWave;
    $[33] = showCreateNewButton;
    $[34] = updateIdentity;
    $[35] = waveName;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== identity || $[38] !== overviewTypes || $[39] !== showAllType || $[40] !== showSearchResults || $[41] !== waveName) {
    t13 = <div className="tw-mt-6">{showSearchResults ? <WavesListSearchResults identity={identity} waveName={waveName} /> : <div className="tw-space-y-8">{overviewTypes.map(type => <WavesListWrapper key={type} overviewType={type} showAllType={showAllType} setShowAllType={setShowAllType} />)}</div>}</div>;
    $[37] = identity;
    $[38] = overviewTypes;
    $[39] = showAllType;
    $[40] = showSearchResults;
    $[41] = waveName;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== t12 || $[44] !== t13) {
    t14 = <div className="tailwind-scope"><div className="tw-pb-14 lg:tw-pb-24 tw-px-2 lg:tw-px-6 xl:tw-px-8 tw-mx-auto">{t12}{t13}</div></div>;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
}
function _temp(t_0) {
  return t_0 !== ApiWavesOverviewType.AuthorYouHaveRepped;
}